<template>
    <div>
        <div style="padding: 10px;">
            <el-card class="box-card" style="width: 50%">
                <div slot="header" class="clearfix">
                    <span>修改密码</span>
                    <el-button style="float:right;" v-loading="saveLoading" type="primary" @click="save">保存</el-button>
                </div>
                <el-form :model="submitForm" ref="submitForm" :rules="rules" label-width="150px">
                    <el-form-item label="旧密码" prop="oldPassword">
                        <el-input style="width: 300px" type="password" v-model="submitForm.oldPassword"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="newPassword">
                        <el-input style="width: 300px" type="password" v-model="submitForm.newPassword"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="confirmPassword">
                        <el-input style="width: 300px" type="password" v-model="submitForm.confirmPassword"></el-input>
                    </el-form-item>

                </el-form>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChangePassword',
    components: {},
    data() {
        return {
            saveLoading: false,

            submitForm: {
                oldPassword: "",
                newPassword: "",
                confirmPassword: "",
            },

            rules: {
                oldPassword: [{
                    required: true,
                    message: '请输入旧密码',
                    trigger: 'blur'
                }],
                newPassword: [{
                    required: true,
                    message: '请输入新密码',
                    trigger: 'blur'
                }, { validator: this.passWordValidator, trigger: 'blur' }],
                confirmPassword: [{
                    required: true,
                    message: '请输入确认密码',
                    trigger: 'blur'
                }, { validator: this.passWordValidator, trigger: 'blur' }],
            }
        }
    },
    activated() {

    },
    deactivated() {
        if (this.$refs['submitForm']) {
            this.$refs['submitForm'].resetFields();
        }
    },
    methods: {
        save() {
            this.$refs['submitForm'].validate((valid) => {
                if (valid) {
                    if (this.submitForm.newPassword != this.submitForm.confirmPassword) {
                        this.$message({
                            message: '新密码与确认密码不一致',
                            type: 'warning'
                        });
                        return
                    }
                    var parent = this;
                    parent.saveLoading = true;
                    this.$httpAuth
                        .post("/v1/backendOperatorRpc/updatePassword", {
                            "oldPassword": this.md5(this.submitForm.oldPassword),
                            "newPassword": this.submitForm.newPassword,
                        })
                        .then(function (response) {
                            parent.saveLoading = false
                            parent.submitForm = {
                                oldPassword: "",
                                newPassword: "",
                                confirmPassword: "",
                            }

                            parent.$message({
                                message: '密码修改成功!',
                                type: 'success'
                            });
                        })
                        .catch(() => {
                            parent.saveLoading = false
                        });
                }
            });

        },
        passWordValidator(rule, value, callback) {
            const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@_])[A-Za-z\d@_]{7,17}$/;
            if (!passwordPattern.test(value)) {
                callback(new Error('大小写字母+数字+特殊字符（@或下划线)三种组合，长度8~18'));
            } else {
                callback(); // 校验通过
            }
        },
    }
}
</script>
